import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { LoadingModal } from './LoadingModal';
import { useSelector, useDispatch } from 'react-redux';
import { clearError, deleteEvent } from '../redux/slices/eventsSlice';

const DeleteEventModal = ({ setDeleteModal, setViewEvent, viewEvent }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.events.loading);
  const error = useSelector((state) => state.events.error);

  useEffect(() => {
    // Clear any existing errors when component mounts
    dispatch(clearError());

    // Clean up when component unmounts
    return () => {
      dispatch(clearError());
    };
  }, [dispatch]);

  const handleDismissError = () => {
    dispatch(clearError());
    setDeleteModal(false);
    setViewEvent(null);
  };

  const handleDelete = async (e) => {
    e.preventDefault();
    try {
      await dispatch(deleteEvent(viewEvent._id)).unwrap();
      toast.success(t('eventManagement.success.eventDeleted'));
      setDeleteModal(false);
      setViewEvent(null);
    } catch (error) {
      console.error('Error deleting event:', error);
      toast.error(t('eventManagement.errors.deleteFailed'));
    }
  };

  return (
    <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center bg-black bg-opacity-50 z-50">
      {(loading || error) && (
        <LoadingModal
          message={t('eventManagement.deleteModal.deletingEvent')}
          error={error}
          onClose={error ? handleDismissError : null}
        />
      )}
      {!loading && !error && (
        <div className="bg-white p-8 rounded-md shadow-lg w-1/2 max-w-lg">
          <form onSubmit={handleDelete}>
            <label className="block mb-2 text-lg font-bold">
              {t('eventManagement.deleteModal.title')}{' '}
              <span className="text-red-600">{t('eventManagement.deleteModal.deleteWord')} </span>{' '}
              {t('eventManagement.deleteModal.thisEvent')}{' '}
              <div className="text-center font-semibold my-4 text-lg">{viewEvent.name}</div>
            </label>
            <div className="flex justify-end">
              <button
                className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded-md"
                type="submit"
                disabled={loading}
              >
                {loading
                  ? t('eventManagement.deleteModal.deleting')
                  : t('eventManagement.deleteModal.confirm')}
              </button>
              <button
                className="ml-4 bg-gray-500 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded-md"
                onClick={() => {
                  setDeleteModal(false);
                  setViewEvent(null);
                }}
                type="button"
                disabled={loading}
              >
                {t('eventManagement.deleteModal.cancel')}
              </button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
};

export { DeleteEventModal };
